import {Component, OnDestroy, OnInit} from '@angular/core';
import {TeamService} from '@core/services/team.service';
import {LeagueService} from '@core/services/league.service';
import {UserService} from '@core/services/user.service';
import {SnackbarService} from '@core/services/snackbar.service';
import {AppTeam} from '@shared/models/team';
import {User} from '@shared/models/user';
import {StateService} from '@core/services/state.service';
import {LayoutService} from '@utils/services/layout/layout.service';
import {Subscription} from 'rxjs';
import {EntityType} from '@lib/models/entity/entity-type';
import {FollowService} from '@core/services/follow/follow.service';
import {AnalyticsService} from '@utils/services/analytics/analytics.service';
import { UrlService } from '@utils/services/url/url.service';

@Component({
  selector: 'app-team-start-page',
  templateUrl: './team-start-page.component.html',
  styleUrls: ['./team-start-page.component.scss', '../../../../shared/styles/entity-start-page.component.scss']
})
export class TeamStartPageComponent implements OnInit, OnDestroy {

  public team: AppTeam;
  public leagueLink: string = null;
  public leagueName: string = null;
  public teamTitleImageUrl: string;
  public isFollowed  = false;
  public showId = !StateService.isProd;
  private currentUser: User;
  private user$: Subscription;

  constructor( public teamService: TeamService,
               private leagueService: LeagueService,
               private followService: FollowService,
               private snackBarService: SnackbarService,
               public layoutService: LayoutService,
               public userService: UserService) { }

  public async ngOnInit() {
    this.team = this.teamService.getCurrentTeam();
    AnalyticsService.currentEntity = this.team.getAsEntity();
    await this.initTeamData();
    this.user$ = this.userService.currentUserSubject.subscribe(user => {
      this.currentUser = user;
      this.updateFollowStatus();
    });
  }

  public ngOnDestroy() {
    AnalyticsService.currentEntity = null;
    this.user$?.unsubscribe();
  }

  public async initTeamData(): Promise<void> {
    const titlePic = this.team.pictures?.find((pic) => pic.subtype === 'title_image');
    if (titlePic?.resized_files?.length > 0) {
      // Third index is the image with the highest res
      this.teamTitleImageUrl = titlePic.resized_files[2].url;
    } else {
      this.teamTitleImageUrl = 'assets/images/soccer-field-c.jpg';
    }
    this.leagueName = this.team.getLeagueUIName();
    if (this.teamService.league) {
      this.leagueLink = UrlService.getSubdomainUrl(this.teamService.league.readable_id);
    }
  }

  public async toggleFollow() {
    const success = await this.followService.toggleFollow(!this.isFollowed, EntityType.Team, this.team.name, this.team.id);
    if (success) {
      this.updateFollowStatus();
    }
  }

  private updateFollowStatus() {
    this.isFollowed = this.followService.userFollows(EntityType.Team, this.team.id);
  }

  public copyEntityId() {
    navigator.clipboard.writeText(this.team.id).then(() => {
      this.snackBarService.showSimpleSnackbar('ID wurde kopiert');
    });
  }
}
